module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/reservation/reservation-categories/reservation-categories.component.scss
// module id = ./src/app/reservation/reservation-categories/reservation-categories.component.scss
// module chunks = main